<script>
import tippy from 'tippy.js'

export default {
    methods: {
        triggerTippy(event) {
            this.removeTippy()

            let clickedElement = document.elementFromPoint(event.originalEvent.x, event.originalEvent.y)
            let elementClasses = clickedElement.classList
            if (elementClasses.contains('helpIcon')) {
                this.addTippyToNode(clickedElement)
                this.clickedPathInfo = {}
            }
        },
        removeTippy() {
            if (document.querySelector('[data-tippy-root]')) {
                document.querySelector('[data-tippy-root]').remove()
            }
        },
        addTippyToNode(iconDiv, pathPosition=0) {
            let nodeId = $(iconDiv).data('node')
            let node = this.$refs.cy.instance.nodes(`#${nodeId}`)
            let popperPostion = {
                x: node.renderedPosition().x - 5,
                y: pathPosition + node.renderedPosition().y - node.renderedBoundingBox().h/2
            }
            let ref = node.popperRef({renderedPosition: () => (popperPostion)})

            let dummyDomEle = document.createElement("div")
            this.clickedNode = this.assignNodeForTippy(node)

            this.$nextTick(() => {
                dummyDomEle.setAttribute('id', node.data().id + 'tippy')
                dummyDomEle.setAttribute('class', 'tippy')

                let template = document.querySelector('#nodeTippy').cloneNode(true)
                template.style.display = 'block'
                let _this = this

                node.tippy = new tippy(dummyDomEle, {
                    getReferenceClientRect: ref.getBoundingClientRect,
                    arrow: false,
                    allowHTML: true,
                    trigger: "manual",
                    delay: [0, 800],
                    maxWidth: 400,
                    theme: 'light',
                    placement: 'top',
                    content: () => template,
                    onShow(instance) {
                        let actionSelectors = ['.generated', '.source', '#hide', '#show']
                        actionSelectors.forEach(action => {
                            let btn = instance.popper.querySelector(action)
                            if (btn) {
                                btn.addEventListener('click', () => {
                                    _this.triggerTippyEvents(node.data().id, action.substring(1))
                                })
                            }
                        })
                    },
                    // placement: placement,
                    hideOnClick: false,
                    interactive: true,
                    appendTo: document.body
                })
                node.tippy.show()
            })
        },
        addTippyToEdge(edge) {
            let ref = edge.popperRef()
            let dummyDomEle = document.createElement("div")
            this.clickedNode = this.assignNodeForTippy(edge)
            this.$nextTick(() => {
                dummyDomEle.setAttribute('id', edge.data().id + 'tippy')
                let template = document.querySelector('#nodeTippy').cloneNode(true)
                template.style.display = 'block'
                let _this = this
                edge.tippy = new tippy(dummyDomEle, {
                    getReferenceClientRect: ref.getBoundingClientRect,
                    arrow: true,
                    allowHTML: true,
                    trigger: "manual",
                    delay: [0, 800],
                    maxWidth: 400,
                    theme: 'light',
                    content: () => template,
                    onShow(instance) {
                        let actionSelectors = ['.generated', '.source', '#hide', '#show']
                        actionSelectors.forEach(action => {
                            let btn = instance.popper.querySelector(action)
                            if (btn) {
                                btn.addEventListener('click', () => {
                                    _this.triggerTippyEvents(edge.data().id, action.substring(1))
                                })
                            }
                        })
                    },
                    placement: "bottom",
                    hideOnClick: false,
                    interactive: true,
                    appendTo: document.body
                })
                edge.tippy.show()
            })
        },

        // Assign node data into a new node's data
        assignNodeForTippy(node) {
            let clickedNode = {}
            clickedNode.isEdge = node.isEdge()
            clickedNode.data = node.data()
            clickedNode.classes = node.classes()

            return clickedNode
        },

        // Trigger events inside tippy
        triggerTippyEvents(id, action) {
            this.loadExtraNodes = true
            this.ready = false
            let newData = id + action
            this.requestedData.push(newData)
            this.addMoreData(id, action)
        },
    }
}
</script>

